import {HOPSApplication} from "@hps/hops-react";
import * as Sentry from "@sentry/react";
import React, {useState} from "react";
import {Provider as ReduxProvider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";

import ErrorGate from "Components/ErrorGate.js";
import F12 from "F12/F12.js";

import Main from "./Main.js";
import {Store, StorePersistor} from "./Store.js";


/**
 * App
 *
 * @package HOPS
 * @subpackage App
 * @copyright Heritage Operations Processing Limited
 */
const App = () => {

	const [orgTheme, setOrgTheme] = useState(null);

	/** Theme updated by registration */
	const handleOrgThemeUpdated = theme => {
		setOrgTheme(theme);
	};

	return (
		<Sentry.ErrorBoundary fallback={<ErrorGate />}>
			<ReduxProvider store={Store}>
				<PersistGate loading={null} persistor={StorePersistor}>
					<BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
						<HOPSApplication orgTheme={orgTheme}>
							<Sentry.ErrorBoundary fallback={<ErrorGate />}>
								<F12 />
								<Main onThemeUpdated={handleOrgThemeUpdated} />
							</Sentry.ErrorBoundary>
						</HOPSApplication>
					</BrowserRouter>
				</PersistGate>
			</ReduxProvider>
		</Sentry.ErrorBoundary>
	);

};

export default App;
